// extracted by mini-css-extract-plugin
module.exports = {"item":"ItemCart_item__3dVKQ","itemImage":"ItemCart_itemImage__1lhRX","itemName":"ItemCart_itemName__34yNt","itemPrice":"ItemCart_itemPrice__3LB0e"};